import { AnyAction } from 'redux';

import { stationsActions } from '../reducer';

import { Station } from 'dataSources/Typicode/stations';

export const removeSelectedStationOnRoute = (stationCode: Station['code']): AnyAction =>
  stationsActions.removeSelectedStationOnRoute(stationCode);
